<template>
  <div
    class="mobile-button"
    @click="
      () => {
        open = !open
        $emit('toggleMobileNav')
      }
    "
  >
    <div
      :class="{ 'tw-rotate-45': open }"
      class="tw-transform tw-transition tw-duration-200 tw-origin-top-left"
    ></div>
    <div
      :class="{ 'tw-opacity-0': open }"
      class="tw-transition tw-duration-200"
    ></div>
    <div
      :class="{ 'tw--rotate-45': open }"
      class="tw-transform tw-transition tw-duration-200 tw-origin-bottom-left"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false
    }
  },
  watch: {
    open(value) {
      if (value) {
        document.body.classList.add('tw-overflow-hidden')
        document.body.classList.add('tw-relative')
        document.querySelector('html').classList.add('tw-overflow-hidden')
      } else {
        document.body.classList.remove('tw-overflow-hidden')
        document.body.classList.remove('tw-relative')
        document.querySelector('html').classList.remove('tw-overflow-hidden')
      }
    }
  }
}
</script>

<style lang="scss"></style>
